import { GenericList } from '../../components/GenericList'
import {
  goldSavingsRepo,
  karigarRepo,
  jewelryCertificateRepo,
  stockTransferRepo
} from '../../lib/db'

export function JewelrySavingsPage() {
  return (
    <div className="p-6">
      <h2 className="text-2xl font-bold text-gray-900 mb-6">Gold Savings Schemes</h2>
      <GenericList entityName="gold_savings_schemes" repo={goldSavingsRepo} />
    </div>
  )
}

export function JewelryKarigarPage() {
  return (
    <div className="p-6">
      <h2 className="text-2xl font-bold text-gray-900 mb-6">Karigars (Goldsmiths)</h2>
      <GenericList entityName="karigars" repo={karigarRepo} />
    </div>
  )
}

export function JewelryCertificatePage() {
  return (
    <div className="p-6">
      <h2 className="text-2xl font-bold text-gray-900 mb-6">Jewelry Certificates</h2>
      <GenericList entityName="jewelry_certificates" repo={jewelryCertificateRepo} />
    </div>
  )
}

export function JewelryTransferPage() {
  return (
    <div className="p-6">
      <h2 className="text-2xl font-bold text-gray-900 mb-6">Stock Transfers</h2>
      <GenericList entityName="stock_transfers" repo={stockTransferRepo} />
    </div>
  )
}
